import { FC } from 'react';
import classNames from 'classnames';

import { useEmergencyBannerData } from './useEmergencyBannerData';

type EmergencyBannerProps = {};

export const EmergencyBanner: FC<EmergencyBannerProps> = ({}) => {
    const { data } = useEmergencyBannerData();

    if (!data) {
        return null;
    }

    return (
        <div
            className={classNames(
                'border-none w-full min-h-7 flex items-center justify-center px-4 text-small-text-13 hover:opacity-90 transition-opacity duration-200',
                data.bg,
            )}
            style={{ zIndex: 60 }}>
            {data.content}
        </div>
    );
};
